import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { ActiveMask, FlexInner, StyledSwitch, SwitchOption } from "./styled"

export interface ISwitchOption {
  label: string
  value: string | number
}

const SwitchSelector = ({
  options,
  value,
  onChange,
  disabled = false,
}: {
  options: [ISwitchOption, ISwitchOption]
  value: string
  onChange: (value: string | number) => void
  disabled?: boolean
}) => {
  const activeIndex = options.findIndex((option) => option.value === value)
  const nextValue = activeIndex === 0 ? options[1].value : options[0].value

  const option1Ref = useRef<HTMLDivElement>(null)
  const option2Ref = useRef<HTMLDivElement>(null)

  const [optionWidth, setOptionWidth] = useState(0)

  const [hasTransition, setHasTransition] = useState(false)

  useEffect(() => {
    const getOptionWidth = (ref: React.RefObject<HTMLDivElement>) => {
      if (ref.current) {
        return ref.current.getBoundingClientRect().width
      }

      return 0
    }

    if (activeIndex === 0 && option1Ref.current) {
      setOptionWidth(getOptionWidth(option1Ref))
    }
    if (activeIndex === 1 && option2Ref.current) {
      setOptionWidth(getOptionWidth(option2Ref))
    }

    setTimeout(() => {
      setHasTransition(true)
    }, 500)
  }, [activeIndex])

  return (
    <StyledSwitch>
      <FlexInner>
        <ActiveMask
          $width={optionWidth}
          $activeIndex={activeIndex}
          $hasTransition={hasTransition}
        />

        {options.map((option, optionIndex) => (
          <SwitchOption
            ref={optionIndex === 0 ? option1Ref : option2Ref}
            $disabled={disabled}
            $isActive={activeIndex === optionIndex}
            key={option.value}
            onClick={() => {
              if (!disabled) {
                onChange(nextValue)
              }
            }}
          >
            {option.label}
          </SwitchOption>
        ))}
      </FlexInner>
    </StyledSwitch>
  )
}

export default SwitchSelector
